import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactGA from 'react-ga4';
import Hotjar from '@hotjar/browser';

import App from './app/App'
import './index.css'
import { ThemeProvider } from './app/providers/ThemeProvider'
import { GAListener } from './app/GAListener'

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://1a840b07dca676d898f09892df7de75b@o4509865962438656.ingest.de.sentry.io/4509867080351824",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
// Initialize GA once
if (measurementId) {
    ReactGA.initialize(measurementId);
    Hotjar.init(6444796, 6);
} else {
    console.warn("No measurement ID found");
}

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <BrowserRouter>
          <GAListener>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </GAListener>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>,
)
